








import Vue from 'vue'
export default Vue.extend({
  methods: {
    focusOnMain() {
      document.getElementsByTagName('main')[0].focus()
    },
  },
})
